class MemoryStorage implements Storage {
  private map = new Map();

  get length() {
    return this.map.size;
  }

  public key(idx: number) {
    return Array.from(this.map.keys())[idx];
  }

  public getItem(key: string) {
    return this.map.get(key);
  }

  public setItem(key: string, value: string) {
    return this.map.set(key, value);
  }

  public removeItem(key: string) {
    return this.map.delete(key);
  }

  public clear() {
    return this.map.clear();
  }
}

export { MemoryStorage };
